import { FC, useContext } from 'react';
import Card from '../Card/Card';
import { IconGoogleAppStore, IconAppleAppStore, IconSuccess } from '../../icons/Icons';
import language from '../../util/language';
import common from '../../util/scss/common.module.scss';
import styles from './ConfirmStaffAccountSuccess.module.scss';
import { ELinks } from '../../util/constants';
import GlobalContext from '../../contexts/GlobalContext';

const ConfirmStaffAccountSuccess: FC = () => {
    const { webClientsBaseUrl, subscriberId } = useContext(GlobalContext);
    const launchPageLink = `${webClientsBaseUrl}/launch`;
    const loginLaunchPageLink = `${webClientsBaseUrl}/loginlaunch?studioid=${subscriberId}`;

    return (
        <Card>
            <section className={`${common.icon}`}>
                <IconSuccess width={'50'} height={'50'} fillColor={'777982'} />
            </section>
            <header>
                <h1 className={`${common.pageHeader} ${common.withSubhead}`}>
                    {language.confirmStaffAccount.success.header}
                </h1>
                <p className={`${common.pageSubhead}`} data-testid={'verify-desc'}>
                    {language.confirmStaffAccount.success.desc}
                </p>
            </header>
            <section className={styles.downloadCtas}>
                <a href={ELinks.mindbodyAppAndroid} data-testid="android-app-link">
                    <IconGoogleAppStore width={'140px'} height={'100%'} />
                </a>
                <a href={ELinks.mindbodyAppIos} data-testid="apple-app-link">
                    <IconAppleAppStore width={'140px'} height={'100%'} />
                </a>
            </section>
            <section className={styles.loginCta}>
                <a href={subscriberId ? loginLaunchPageLink : launchPageLink}>
                    {language.confirmStaffAccount.success.loginCta}
                </a>
            </section>
        </Card>
    );
};

export default ConfirmStaffAccountSuccess;
